import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import IconButton from '../../IconButton/index.esm.js';
import { usePopoverContext } from '../context.esm.js';

var PopoverCloseButton = function PopoverCloseButton(props) {
  var _usePopoverContext = usePopoverContext(),
      onClose = _usePopoverContext.onClose;

  return React__default.createElement(IconButton, _extends({
    icon: "close",
    label: "close",
    appearance: "ghost",
    iconSize: "sm",
    width: "w-6",
    height: "h-6",
    padding: "p-0",
    position: "absolute",
    inset: ['top-1', 'right-2']
  }, props, {
    onClick: onClose
  }));
};

if (__DEV__) {
  PopoverCloseButton.displayName = 'PopoverCloseButton';
}

export default PopoverCloseButton;
//# sourceMappingURL=index.esm.js.map
